import './Welcome.css';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';

const Welcome = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const app = useSelector((state) => state.app);
  const logo = app?.platformMedia?.find((m) => m.type === 'LOGO_TRANSPARENT')?.value;

  useEffect(() => {
    document.body.classList.add('welcome');

    return () => {
      document.body.classList.remove('welcome');
    };
  });

  const onSignInHandle = () => {
    history.push({
      pathname: '/login-user',
    });
  };

  const onSignUpHandle = (e) => {
    e.preventDefault();
    window.location.href = 'https://www.wellet.pro';
  };

  if(!app) return null;

  return (
    <>
      <div className='logo'>
        <img
          alt='WelletPro'
          src={logo}
        />
      </div>

      <div className='actions'>
        <button className='wl-btn-primary' onClick={onSignInHandle}>
          {t('login.signIn')}
        </button>
        {/* <a href='#' className='link' onClick={(e) => onSignUpHandle(e)}>
          {t('login.signUp')}
        </a> */}
      </div>
    </>
  );
};

export default Welcome;
